export function getMapping(index) {

    var routes = {
        "LocaModule"  : "/"
    };
    return routes[index];
}

export function isPublicUser() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user && user.roles) {

        if (user.roles.includes('LocaModule')) {
            return false;
        }
    }

    return true;
}